import React, { Component, Fragment } from 'react'
import { withStyles } from '@material-ui/core/styles'

// COMPONENTS
import Typography from '@material-ui/core/Typography'
import LeftNavigationDashboard from '../components/app-navigation/LeftNavigationDashboard'

import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import LogoData from '../components/app-logo/logo-data'
import CustomizeAll from '../components/сustomize-all/'
import TableManualCosting from '../components/table'
import TraficLight from '../components/traficLight'
import LicenseExpired from '../components/payment/LicenseExpired'
import { ActionsForUsing } from '../components/payment/LicenseExpired'

const styles = theme => ({
  pageTemplate: {
    maxWidth: 1072,
    margin: '0 auto',
  },
  wizardRow: {
    padding: '0 24px',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },
  wizardContent: {
    maxWidth: 940,
    width: '100%',
  },
  header: {
    padding: '15px 40px 6px 22px',
  },
  content: {
    padding: '16px 40px 30px 22px',
  },
  viewList: {
    margin: 0,
    padding: 0,
  },
  list: {
    padding: 0,
    listStyleType: 'none',
  },
  item: {
    marginBottom: 12,
  },
  link: {
    display: 'inline-flex',
    alignItems: 'center',
    fontSize: 16,
    fontWeight: 'normal',
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 1.5,
    letterSpacing: 'normal',
    color: 'rgb(136, 102, 255)',
    '&:hover': {
      textDecoration: 'none',
    },
  },
  icon: {
    width: 40,
    height: 40,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    boxShadow: '0 16px 32px 0 rgba(0, 0, 0, 0.12)',
    backgroundColor: 'rgb(255, 204, 0)',
    borderRadius: '100%',
    marginRight: 15,
  },
  chanelList: {
    listStyleType: 'none',
    padding: 0,
    margin: 0,
  },
  chanel: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '13px 15px 13px 32px',
  },
  chanelInfo: {
    listStyleType: 'none',
    padding: 0,
    marginLeft: 8,
    marginRight: 65,
    flex: 1,
  },
  chanelTitle: {
    fontFamily: 'Roboto',
    fontSize: 14,
    color: 'rgba(0, 0, 0, 0.75)',
  },
  chanelStatus: {
    fontFamily: 'Roboto',
    fontSize: 10,
    lineHeight: 1.6,
    color: 'rgba(0, 0, 0, 0.5)',
  },
  chanelStatusIcon: {
    width: 16,
    height: 16,
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingTop: theme.spacing.unit * 3,
    paddingBottom: theme.spacing.unit * 3,
    paddingLeft: theme.spacing.unit * 2,
    paddingRight: theme.spacing.unit * 2,
    [theme.breakpoints.up('md')]: {},
    '@media (min-width:960px)': {
      // eslint-disable-line no-useless-computed-key
      paddingLeft: theme.spacing.unit * 8,
      paddingRight: theme.spacing.unit * 8,
    },
  },
  link: {
    textDecoration: 'none',
  },
  toolbarInner: {
    padding: 0,
  },
  extendedIcon: {
    marginRight: 5,
  },
  container: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginLeft: 32,
    background: '#fff',
    borderRadius: 32,
  },
  info: {
    margin: 0,
    padding: 0,
    flex: 1,
  },
  siteIcon: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: 24,
    height: 24,
    margin: '0 19px 0 23px',
    color: '#fff',
    fontSize: 16,
    fontWeight: 600,
    borderRadius: '100%',
    backgroundColor: 'rgb(44, 50, 157)',
  },
  list: {
    margin: '0 0 16px 0',
    padding: '7px 14px 10px 40px',
    listStyleType: 'none',
    borderRadius: 4,
  },
  titleList: {
    maxWidth: 390,
    margin: '0 0 32px 0',
  },
})

class DashBoardStatistics extends Component {
  state = {
    site: window.state.site,
    statistics: window.state.statistics,
  }

  render() {
    const { classes } = this.props
    const { site, statistics } = this.state

    return (
      <Fragment>
        <LicenseExpired>
          <ActionsForUsing />
        </LicenseExpired>
        <div className={classes.pageTemplate}>
          <AppBar
            position="static"
            color="inherit"
            elevation={0}
            style={{ padding: '24px' }}
          >
            <Toolbar className={classes.toolbarInner}>
              <LogoData />

              <a className={classes.container} href={`http://${site.url.replace(/(http|https):\/\//is, '')}`} target="_blank">
                <div className={classes.siteIcon}>S</div>
                <ul className={classes.info}>
                  <Typography component="li" variant="body1">
                    {site.url}
                  </Typography>
                  <Typography component="li" variant="overline">
                    {site.name}
                  </Typography>
                </ul>
              </a>

              <TraficLight />
            </Toolbar>
          </AppBar>

          <CustomizeAll />

          <div className={classes.wizardRow}>
            <LeftNavigationDashboard />

            <div className={classes.wizardContent}>
              <div
                style={{
                  marginLeft: 41,
                  width: 600,
                  marginBottom: 50,
                }}
              >
                {statistics && statistics.length ? (
                  <Fragment>
                    <Typography variant="body1" className={classes.titleList}>
                      Ручная передача расходов из рекламных площадок в Google
                      Analytics
                    </Typography>
                    <Typography
                      variant="subtitle1"
                      component="div"
                      style={{
                        width: 567,
                        marginBottom: 24,
                        padding: '6px 13px 6px',
                        backgroundColor: 'rgba(255, 204, 0, .2)',
                      }}
                    >
                      <div style={{ margin: 0, fontWeight: 600 }}>
                        Обратите внимание:
                      </div>
                      <div style={{ margin: 0 }}>
                        пожалуйста, для корректного построения отчетов
                        указывайте сумму расходов с НДС.
                      </div>
                    </Typography>
                    <TableManualCosting data={statistics} />
                  </Fragment>
                ) : (
                  <Fragment>
                    <p>Данных по расходам пока что нет.</p>
                    <Typography variant="subtitle1" paragraph>
                      Вы сможете заносить расходы по тем каналам, которые
                      недоступны для автоматического импорта, как только мы
                      начнем получать данные из вашего Google Analytics аккаунта
                      (получение данных происходит не реже чем раз в 15 минут).
                    </Typography>
                  </Fragment>
                )}
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    )
  }
}

export default withStyles(styles)(DashBoardStatistics)
